import { TALES_COLORS } from "../../../utils/constants";

export const mainTheme = {
  talesAccent: TALES_COLORS.accent,
  talesPrimary: TALES_COLORS.primary,
  talesSecondary: TALES_COLORS.secondary,
  talesPink: TALES_COLORS.pink,

  talesLightYellow: TALES_COLORS.lightYellow,
  talesYellow: TALES_COLORS.yellow,
  talesWhite: TALES_COLORS.white,
  talesBlack: TALES_COLORS.black,
  talesDarkEye: TALES_COLORS.darkEye,
  talesLightEye: TALES_COLORS.lightEye,
  talesBackground: TALES_COLORS.background,
  text: TALES_COLORS.text,
};
